function noop() {
  // no operation performed
}

export { noop };
